import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/home/Home';
import SectorSelectionPage from './pages/sector-selection/SectorSelectionPage';
import TemplatesPage from './pages/templates/TemplatesPage';
import UserDetailsPage from './pages/user-details/UserDetailsPage';
import Medium from './features/medium/Medium';
import { RestaurantEditable } from './sectors/food';
import FoodTemplate1 from './sectors/food/templates/food-template-1/FoodTemplate1';
import UniversalDashboard from './pages/dashboard/UniversalDashboard';
import WebsiteBuilderPage from './pages/website-builder/WebsiteBuilderPage';
import GeneratedWebsitesPage from './pages/generated-websites/GeneratedWebsitesPage';
import PaymentPage from './pages/payment/PaymentPage';
import TokenHandler from './components/TokenHandler';
import { getScanHistory } from './utils/storage';

// Components for bottom nav routes
const SearchPage = () => (
   <div className="page-content">
      <h2>Search Page</h2>
      <p>Search functionality coming soon...</p>
   </div>
);

const ScanPage = () => (
   <div className="page-content">
      <h2>Scan Page</h2>
      <p>Use the QR scanner in the bottom navigation to scan QR codes.</p>
   </div>
);

const AlertsPage = () => (
   <div className="page-content">
      <h2>Alerts Page</h2>
      <p>Your notifications will appear here.</p>
   </div>
);

const HistoryPage = () => {
   const history = getScanHistory();
   const [copiedId, setCopiedId] = useState(null);

   const copyToClipboard = async (text, id) => {
      try {
         await navigator.clipboard.writeText(text);
         setCopiedId(id);
         setTimeout(() => setCopiedId(null), 2000);
      } catch (err) {
         console.error('Failed to copy text: ', err);
      }
   };

   return (
      <div className="page-content">
         <h2>Scan History</h2>
         {history.length === 0 ? (
            <p>No scan history yet. Start scanning QR codes to see them here.</p>
         ) : (
            <div className="history-list">
               {history.map((entry) => (
                  <div key={entry.id} className="history-item">
                     <div className="history-data">
                        <a href={entry.data} target="_blank" rel="noopener noreferrer">
                           {entry.data}
                        </a>
                     </div>
                     <div className="history-actions">
                        <button
                           className="copy-button"
                           onClick={() => copyToClipboard(entry.data, entry.id)}
                        >
                           {copiedId === entry.id ? 'Copied!' : 'Copy'}
                        </button>
                     </div>
                     <div className="history-timestamp">
                        {new Date(entry.timestamp).toLocaleString()}
                     </div>
                  </div>
               ))}
            </div>
         )}
      </div>
   );
};

function App() {
   return (
      <Router>
         <TokenHandler />
         <Routes>
            <Route path="/" element={<MainLayout />}>
               <Route index element={<Home />} />
               <Route path="home" element={<Home />} />
               <Route path="dashboard" element={<UniversalDashboard />} />
               <Route path="search" element={<SearchPage />} />
               <Route path="scan" element={<ScanPage />} />
               <Route path="alerts" element={<AlertsPage />} />
               <Route path="history" element={<HistoryPage />} />
               <Route path="sector-selection" element={<SectorSelectionPage />} />
               <Route path="templates" element={<TemplatesPage />} />
               <Route path="user-details/:templateId" element={<UserDetailsPage />} />
               <Route path="website-builder" element={<WebsiteBuilderPage />} />
               <Route path="my-websites" element={<GeneratedWebsitesPage />} />
               <Route path="payment" element={<PaymentPage />} />
               <Route path="jgrpsercstyshh/:id" element={<Medium />} />
               <Route path="restaurant-editable/:id" element={<RestaurantEditable />} />
               <Route path="food-template-1/:id" element={<FoodTemplate1 />} />
            </Route>
         </Routes>
      </Router>
   );
}

export default App;